type ConformityDecision = 'PENDING' | 'ACCEPTED' | 'REJECTED';

export type ConformitySummary = {
  accepted: number;
  total: number;
};

export function getCategoryConformitySummary({
  categoryByDocumentId,
  conformityByDocumentId,
}: {
  categoryByDocumentId: ReadonlyMap<string, string>;
  conformityByDocumentId?: ReadonlyMap<string, { decision: ConformityDecision }>;
}): ConformitySummary {
  const categories = new Set(categoryByDocumentId.values());
  const acceptedCategories = new Set<string>();

  for (const [documentId, { decision }] of conformityByDocumentId?.entries() ?? []) {
    if (decision !== 'ACCEPTED') continue;

    const category = categoryByDocumentId.get(documentId);
    if (category) acceptedCategories.add(category);
  }

  return { accepted: acceptedCategories.size, total: categories.size };
}
